import React from 'react'
import { useIntl } from 'react-intl'
import { Link } from 'react-router-dom'
import { ContentHeader } from '../../scenes/styled'
import { CartOverview } from 'components/CartOverview'
import { Container } from './styled'
import { PlaceOrder } from '../../components/PlaceOrder'

export const CheckoutAside = () => {
  const intl = useIntl()
  return (
    <Container>
      <div className='overview'>
        <ContentHeader>
          <span>{intl.formatMessage({ id: 'checkout.cart.overview' })}</span>
        </ContentHeader>
        <CartOverview />
        <PlaceOrder />
      </div>
      <div className='linkWrapper'>
        <Link
          to='/cart'
        >
          Edit Cart
        </Link>
      </div>
    </Container>
  )
}
